/* Lorelia Startseite 2026 (lr26) · ein Skript für alle lr26-Abschnitte, ohne Abhängigkeiten.
   Grundsatz: Ohne JS ist alles sichtbar und bedienbar. Bewegung nur bei prefers-reduced-motion: no-preference.
   Jeder Abschnitt bindet dieses Skript ein; es läuft trotzdem nur einmal. */
(function () {
  'use strict';
  if (window.LR26) return;
  var LR26 = window.LR26 = { version: 1 };
  var D = document;
  var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var qsa = function (s, el) { return Array.prototype.slice.call((el || D).querySelectorAll(s)); };
  var klemme = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var ein = function (x) { x = klemme(x); return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
  var raus = function (x) { x = klemme(x); return 1 - Math.pow(1 - x, 3); };
  var hoehe = function () { return window.innerHeight || D.documentElement.clientHeight; };

  /* Ein gemeinsamer Scroll-Takt. Horizon scrollt am Desktop .page-wrapper, am Handy das Dokument:
     Capture am Dokument fängt beides. */
  var imTakt = [], geplant = 0;
  function takt() { geplant = 0; for (var i = 0; i < imTakt.length; i++) imTakt[i](); }
  function planen() { if (!geplant) geplant = requestAnimationFrame(takt); }
  D.addEventListener('scroll', planen, { capture: true, passive: true });
  window.addEventListener('resize', planen, { passive: true });

  /* Zahlen zählen hoch, wenn ihre Gruppe erscheint */
  function zaehlen(g) {
    qsa('[data-lr26-zahl]', g).forEach(function (el, i) {
      var ziel = parseInt(el.getAttribute('data-lr26-zahl'), 10) || 0, t0 = 0, D = 900, verz = 420 + i * 90;
      el.textContent = '0';
      setTimeout(function () { requestAnimationFrame(function f(t) { if (!t0) t0 = t; var q = Math.min(1, (t - t0) / D); el.textContent = Math.round(ziel * (1 - Math.pow(1 - q, 3))); if (q < 1) requestAnimationFrame(f); }); }, verz);
    });
  }
  /* ---------- Einblenden: nur was beim Laden unterhalb des Sichtbereichs liegt, wartet ---------- */
  function einblenden() {
    if (ruhig || !hatIO) return;
    var H = hoehe();
    var io = new IntersectionObserver(function (liste) {
      liste.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.remove('ist-warte'); zaehlen(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    qsa('.lr26-rein-gruppe').forEach(function (g) {
      if (g.getBoundingClientRect().top > H * .94) { g.classList.add('ist-warte'); io.observe(g); }
    });
  }

  /* ---------- 1 Held: Punkt-Übergang, eine Runde, dann Stillstand (WCAG 2.2.2) ---------- */
  var IC_PLAY = '<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true" focusable="false"><path d="M3 1.5v9l7.5-4.5z"/></svg>';
  function held(b) {
    var figs = qsa('[data-bild]', b), n = figs.length;
    if (!n) return;
    var punkt = b.querySelector('[data-punkt]'), pause = b.querySelector('[data-pause]');
    var fort = qsa('[data-fort] button', b), balken = fort.map(function (x) { return x.querySelector('b'); });
    var chip = b.querySelector('[data-chip]'), chipM = b.querySelector('[data-chip-marke]'), chipD = b.querySelector('[data-chip-detail]');
    var IC_PAUSE = pause ? pause.innerHTML : '';
    var STAND = 5600;
    var idx = 0, t = 0, letzt = 0, raf = 0, aufraeumen = 0;
    var lauf = !ruhig && n > 1, hover = false, sicht = true, bereit = false;

    function ausrichten(fig) {
      var img = fig.querySelector('img'); if (!img) return;
      var W = b.clientWidth, H = b.clientHeight;
      var w = img.naturalWidth || +img.getAttribute('width') || W, h = img.naturalHeight || +img.getAttribute('height') || H;
      var s = Math.max(W / w, H / h), rw = w * s, rh = h * s;
      var px = parseFloat(fig.getAttribute('data-px')), py = parseFloat(fig.getAttribute('data-py'));
      if (isNaN(px)) px = .5; if (isNaN(py)) py = .4;
      var ox = Math.min(Math.max(px * rw - W * .5, 0), rw - W), oy = Math.min(Math.max(py * rh - H * .44, 0), rh - H);
      img.style.objectPosition = (-ox).toFixed(1) + 'px ' + (-oy).toFixed(1) + 'px';
      fig._px = (px * rw - ox) / W * 100; fig._py = (py * rh - oy) / H * 100;
    }
    function punktSetzen(fig) {
      b.style.setProperty('--px', fig._px.toFixed(2) + '%');
      b.style.setProperty('--py', fig._py.toFixed(2) + '%');
    }
    function alleAusrichten() { figs.forEach(ausrichten); punktSetzen(figs[idx]); }
    function vorladen(k) {
      var img = figs[k] && figs[k].querySelector('img');
      if (!img) return;
      if (img.loading === 'lazy') img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    }
    function balkenSetzen(p) {
      balken.forEach(function (x, j) { if (x) x.style.setProperty('--f', j < idx ? 1 : j === idx ? p.toFixed(3) : 0); });
    }
    function knopf() {
      if (!pause) return;
      pause.innerHTML = lauf ? IC_PAUSE : IC_PLAY;
      pause.setAttribute('aria-label', lauf ? 'Beispiele anhalten' : 'Beispiele abspielen');
    }
    function chipSetzen(fig) {
      if (!chip) return;
      if (chipM) chipM.textContent = fig.getAttribute('data-marke') || '';
      if (chipD) chipD.textContent = fig.getAttribute('data-detail') || '';
      var ziel = fig.getAttribute('data-ziel'); if (ziel) chip.setAttribute('href', ziel);
      if (!ruhig && chip.animate) chip.animate([{ opacity: .15, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
    function zeige(k) {
      if (k === idx) return;
      clearTimeout(aufraeumen);
      var alt = figs[idx], neu = figs[k];
      figs.forEach(function (f) { if (f !== alt && f !== neu) { f.hidden = true; f.classList.remove('ist-ein', 'ist-auf', 'ist-alt'); } });
      alt.classList.remove('ist-ein', 'ist-auf'); alt.classList.add('ist-alt');
      neu.classList.remove('ist-alt', 'ist-auf');
      vorladen(k);
      neu.hidden = false;
      ausrichten(neu); punktSetzen(neu);
      if (ruhig) {
        alt.hidden = true; alt.classList.remove('ist-alt');
      } else {
        neu.classList.add('ist-ein'); void neu.offsetWidth; neu.classList.add('ist-auf');
        aufraeumen = setTimeout(function () { alt.hidden = true; alt.classList.remove('ist-alt', 'ist-fahrt'); neu.classList.remove('ist-ein', 'ist-auf'); }, 1500);
        if (punkt) { punkt.classList.remove('ist-puls'); void punkt.offsetWidth; punkt.classList.add('ist-puls'); }
      }
      fort.forEach(function (x, j) { if (j === k) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
      idx = k; t = 0;
      fahrt(neu);
      chipSetzen(neu);
      vorladen((k + 1) % n);
    }
    function fahrt(f) { f.classList.remove('ist-fahrt'); void f.offsetWidth; f.classList.add('ist-fahrt'); }
    function aktiv() { return lauf && bereit && !hover && sicht && !D.hidden; }
    function schritt(ts) {
      raf = 0;
      if (!aktiv()) { letzt = 0; return; }
      if (!letzt) letzt = ts;
      t += Math.min(ts - letzt, 100); letzt = ts;
      var p = Math.min(t / STAND, 1);
      balkenSetzen(p);
      if (p >= 1) {
        var nx = (idx + 1) % n, img = figs[nx].querySelector('img');
        if (img && !img.complete && t < STAND + 4000) { /* auf das nächste Bild warten */ }
        else if (nx === 0) { zeige(0); lauf = false; knopf(); balkenSetzen(1); return; }
        else zeige(nx);
      }
      raf = requestAnimationFrame(schritt);
    }
    function starten() { if (!raf && aktiv()) { letzt = 0; raf = requestAnimationFrame(schritt); } }

    alleAusrichten();
    knopf();
    balkenSetzen(lauf ? 0 : 1);
    if (punkt) setTimeout(function () { punkt.classList.add('ist-da'); }, ruhig ? 0 : 350);
    if (n < 2) return;

    if (pause) pause.addEventListener('click', function () {
      lauf = !lauf;
      if (lauf && t >= STAND) t = 0;
      knopf(); starten();
    });
    fort.forEach(function (x, j) {
      x.addEventListener('click', function () { lauf = false; knopf(); zeige(j); balkenSetzen(1); });
    });
    /* Tastatur im Karussell: Automatik aus, bis der Knopf sie wieder startet (APG) */
    b.addEventListener('focusin', function (e) { if (e.target !== pause && lauf) { lauf = false; knopf(); } });
    if (window.matchMedia && matchMedia('(hover: hover)').matches) {
      b.addEventListener('mouseenter', function () { hover = true; });
      b.addEventListener('mouseleave', function () { hover = false; starten(); });
    }
    if (hatIO) new IntersectionObserver(function (e) { sicht = e[0].isIntersecting; starten(); }, { threshold: .35 }).observe(b);
    D.addEventListener('visibilitychange', starten);
    var rz = 0;
    window.addEventListener('resize', function () { cancelAnimationFrame(rz); rz = requestAnimationFrame(alleAusrichten); }, { passive: true });
    figs.forEach(function (f) { var img = f.querySelector('img'); if (img) img.addEventListener('load', function () { ausrichten(f); if (f === figs[idx]) punktSetzen(f); }); });
    /* Erst nach dem Laden der Seite: das erste Bild (LCP) hat die Bühne für sich */
    function los() { setTimeout(function () { bereit = true; vorladen(1); if (!ruhig) fahrt(figs[idx]); starten(); }, 700); }
    if (D.readyState === 'complete') los(); else window.addEventListener('load', los, { once: true });
  }

  /* ---------- 5 Schmuck: Karten fliegen beim Erscheinen automatisch herein ----------
     Luca 02.10.2026: der an den Scroll gekoppelte Zoom wirkte beim schnellen Scrollen wie ein Fehler und die Fotos
     vertragen keinen Zoom -> ruhiges Raster, einmaliges Hereinfliegen (gestaffelt), nichts hängt am Finger. */
  /* 04.10.2026 (P1-49, Luca: „da ist gar keine Animation“): Die Fotos luden erst beim Erscheinen (lazy) und kamen an,
     nachdem die leeren Karten schon gelandet waren. Jetzt: Fotos vorab laden, Flug erst, wenn sie bereit sind (max. 1,2 s),
     etwas weiter (von unten/leicht seitlich), 650 ms ease-out, 90 ms versetzt. Weiter einmalig, nicht ans Scrollen gekoppelt. */
  var FLUG = [[-40, 110, -5], [44, 130, 6], [-52, 150, -4], [36, 170, 4]];
  function schmuck(sk) {
    sk.classList.add('ist-still');
    var karten = qsa('[data-karte]', sk);
    if (ruhig || !hatIO || !karten.length) return;
    karten.forEach(function (k, i) {
      var f = FLUG[i % 4];
      k.style.setProperty('--fx', f[0] + 'px'); k.style.setProperty('--fy', f[1] + 'px'); k.style.setProperty('--fr', f[2] + 'deg');
      k.style.setProperty('--fd', (0.04 + i * 0.09).toFixed(2) + 's');
    });
    var r = sk.getBoundingClientRect();
    if (r.top < innerHeight * 0.85 && r.bottom > 0) return;   /* schon im Bild beim Laden: nicht nachträglich verstecken */
    var bilder = qsa('img', sk);
    function vorladen() { bilder.forEach(function (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); }); }
    function bereit(cb) {
      var offen = bilder.filter(function (im) { return !im.complete; }), fertig = false;
      function los() { if (fertig) return; fertig = true; cb(); }
      if (!offen.length) return los();
      var n = offen.length;
      offen.forEach(function (im) { function eins() { if (--n <= 0) los(); } im.addEventListener('load', eins, { once: true }); im.addEventListener('error', eins, { once: true }); });
      setTimeout(los, 1200);
    }
    sk.classList.add('lr26-sk--flug');
    var nah = new IntersectionObserver(function (e) { if (!e[0].isIntersecting) return; nah.disconnect(); vorladen(); }, { rootMargin: '900px 0px' });
    nah.observe(sk);
    var io = new IntersectionObserver(function (e) {
      if (!e[0].isIntersecting) return;
      io.disconnect(); vorladen();
      bereit(function () {
        requestAnimationFrame(function () { requestAnimationFrame(function () { sk.classList.add('ist-da'); }); });
        setTimeout(function () { sk.classList.remove('lr26-sk--flug'); sk.classList.remove('ist-da'); }, 1900);
      });
    }, { threshold: 0.15 });
    io.observe(sk.querySelector('.lr26-sk__raster') || sk);
  }

  /* ---------- 6 So funktioniert's: goldene Linie + Live-Probe ---------- */
  function schritte(el) {
    if (ruhig) return;
    imTakt.push(function () {
      var r = el.getBoundingClientRect(), H = hoehe();
      if (r.bottom < -200 || r.top > H + 200) return;
      el.style.setProperty('--p', klemme((H * .72 - r.top) / Math.max(1, r.height)).toFixed(3));
    });
  }
  function demo(el) {
    var feld = (el.getAttribute('data-feld') || 'namen').toLowerCase();
    var ziel = el.querySelector('[data-demo-name]'), innen = ziel && ziel.querySelector('span');
    var form = el.querySelector('[data-demo-form]'), input = form && form.querySelector('input');
    if (!innen || !input) return;
    var vorher = input.value;
    function passen() {
      innen.style.transform = '';
      var s = Math.min(1, (ziel.clientWidth - 4) / Math.max(1, innen.offsetWidth));
      if (s < 1) innen.style.transform = 'scale(' + s.toFixed(3) + ')';
    }
    function setzen() {
      var v = input.value;
      innen.textContent = '';
      if (!v.trim()) { innen.textContent = 'Eure Namen'; innen.style.opacity = '.35'; }
      else {
        innen.style.opacity = '';
        if (!ruhig && v.length > vorher.length && v.indexOf(vorher) === 0) {
          innen.appendChild(D.createTextNode(vorher));
          var neu = D.createElement('span'); neu.className = 'ist-neu'; neu.textContent = v.slice(vorher.length);
          innen.appendChild(neu);
        } else innen.textContent = v;
      }
      vorher = v; passen();
    }
    input.addEventListener('input', setzen);
    window.addEventListener('resize', passen, { passive: true });
    passen();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var url = form.getAttribute('action');
      if (!url || url === '#') return;
      var v = input.value.trim();
      if (v) {
        var texte = {}; texte[feld] = v.toUpperCase();
        try { sessionStorage.setItem('lr7-mitnehmen', JSON.stringify({ zeit: Date.now(), texte: texte, ort: '', motivIndex: null })); } catch (x) {}
      }
      /* #gestalten öffnet auf der Produktseite direkt den Gestalter */
      window.location.href = url.split('#')[0] + '#gestalten';
    });
  }

  /* ---------- 7 Bewertungen: Pfeile für die Schiene ---------- */
  function schiene(ul) {
    var nav = ul.parentNode && ul.parentNode.querySelector('[data-schiene-nav]');
    if (!nav) return;
    var z = nav.querySelector('[data-zurueck]'), w = nav.querySelector('[data-weiter]');
    function stand() {
      var max = ul.scrollWidth - ul.clientWidth - 2;
      if (z) z.disabled = ul.scrollLeft <= 2;
      if (w) w.disabled = ul.scrollLeft >= max;
      nav.hidden = max <= 0;
    }
    function gehe(d) { ul.scrollBy({ left: d * ul.clientWidth * .9, behavior: ruhig ? 'auto' : 'smooth' }); }
    if (z) z.addEventListener('click', function () { gehe(-1); });
    if (w) w.addEventListener('click', function () { gehe(1); });
    ul.addEventListener('scroll', stand, { passive: true });
    window.addEventListener('resize', stand, { passive: true });
    stand();
  }

  /* ---------- 8 Gut zu wissen: Größen + Ankunftsdatum ---------- */
  function groessen(gr) {
    var box = gr.parentNode;
    var knoepfe = qsa('.lr26-groessen button', box), masse = qsa('.lr26-mass', gr), info = box.querySelector('[data-gr-info]');
    knoepfe.forEach(function (k) {
      k.addEventListener('click', function () {
        var g = k.getAttribute('data-g');
        knoepfe.forEach(function (x) { x.setAttribute('aria-pressed', x === k ? 'true' : 'false'); });
        masse.forEach(function (m) { m.classList.toggle('ist-aktiv', m.getAttribute('data-g') === g); });
        if (info) info.textContent = k.getAttribute('data-text') || '';
      });
    });
    if (ruhig || !hatIO || gr.getBoundingClientRect().top < hoehe() * .9) return;
    gr.classList.add('ist-warte');
    var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { gr.classList.remove('ist-warte'); io.disconnect(); } }, { threshold: .45 });
    io.observe(gr);
  }
  function ostern(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), x = h + l - 7 * m + 114;
    return new Date(y, Math.floor(x / 31) - 1, (x % 31) + 1, 12);
  }
  function feiertag(d) {
    var md = (d.getMonth() + 1) + '-' + d.getDate();
    if (['1-1', '5-1', '10-3', '12-25', '12-26'].indexOf(md) > -1) return true;
    var diff = Math.round((d - ostern(d.getFullYear())) / 864e5);
    return [-2, 1, 39, 50].indexOf(diff) > -1;   /* Karfreitag, Ostermontag, Himmelfahrt, Pfingstmontag */
  }
  function plusWerktage(start, n) {
    var d = new Date(start.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6 && !feiertag(d)) n--; }
    return d;
  }
  function ankunft(el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 7, max = parseInt(el.getAttribute('data-max'), 10) || 10;
    var heute = new Date(); heute.setHours(12, 0, 0, 0);
    var f = { weekday: 'short', day: 'numeric', month: 'short' };
    var von = plusWerktage(heute, min).toLocaleDateString('de-DE', f), bis = plusWerktage(heute, max).toLocaleDateString('de-DE', f);
    var vorsatz = el.getAttribute('data-vorsatz');
    el.textContent = (vorsatz ? vorsatz + ' ' : '') + 'voraussichtlich ' + von + ' bis ' + bis;
  }

  /* ---------- 10 Schluss: Seidenpapier öffnet sich ---------- */
  function papier(el) {
    if (ruhig) return;
    imTakt.push(function () {
      var r = el.getBoundingClientRect(), H = hoehe();
      if (r.bottom < -200 || r.top > H + 200) return;
      el.style.setProperty('--p', raus((H - r.top) / (H * .65)).toFixed(3));
    });
  }

  function start(wurzel) {
    var r = wurzel || D;
    if (!wurzel) einblenden();
    qsa('[data-lr26-held]', r).forEach(held);
    qsa('[data-lr26-sk]', r).forEach(schmuck);
    qsa('[data-lr26-schritte]', r).forEach(schritte);
    qsa('[data-lr26-demo]', r).forEach(demo);
    qsa('[data-lr26-schiene]', r).forEach(schiene);
    qsa('[data-lr26-gr]', r).forEach(groessen);
    qsa('[data-lr26-ankunft]', r).forEach(ankunft);
    qsa('[data-lr26-papier]', r).forEach(papier);
    takt();
  }
  LR26.start = start;
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { start(); }); else start();
  /* Theme-Editor: neu gerenderte Abschnitte wieder beleben */
  D.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
